export default __webpack_public_path__ + "static/media/mongodb.b8c08730.png";